export const FILTRE_TYPE_INPUT = 'input';
export const FILTRE_TYPE_SELECT = 'select';
export const FILTRE_TYPE_AUTOCOMPLETE_PARAMS = 'autocomplete_params';
export const PER_PAGE_LIST = [5, 10, 20];
